enum StatusBoleto {
  Aberto = 1,
  Quitado = 2,
  Vencido = 3,
  PagoParcialmente = 4,
}

export default StatusBoleto;
